import {
	AssignStatus,
	GetContactInformation,
	GetEmailInformation,
	GetPhoneInformation,
	InclusionStatus,
	ListProcessingStatus,
	ListSourceType,
	ListStatus,
	ListType,
	ResponseStatus,
	SearchBase,
} from "@/enum/list.enum";
import { ListPersonGlobalSearchInfoDTO } from "@/pages/Private/redux/search/search.schema";
import { List, ListPerson } from "@/pages/Private/pages/List/schema/list";

/**
 * Stubs the required fields of List that are absent when item.list is undefined.
 * Lead reads list.id, list.campaignStatus, list.name — everything else is optional
 * or only used by campaign-management affordances that won't appear without real data.
 */
const STUB_LIST: List = {
	id: 0,
	name: "",
	lastRunAt: null,
	refreshEveryXDays: null,
	maxProspects: null,
	onlyNewLeads: false,
	processingStatus: ListProcessingStatus.IDLE,
	searchBase: SearchBase.PERSON,
	sourceType: ListSourceType.EMPTY,
	customColumns: null,
	type: ListType.ONCE,
	iteration: 0,
	updatedAt: new Date(0),
	webhooks: [],
	getContactInformation: GetContactInformation.NONE,
	getEmailInformation: GetEmailInformation.NONE,
	getPhoneInformation: GetPhoneInformation.NONE,
	campaignStatus: null,
	status: ListStatus.PAUSED,
};

/**
 * Adapts a ListPersonGlobalSearchInfoDTO (from the global-search endpoint) to
 * the ListPerson shape that <Lead> expects.
 *
 * Required campaign-specific fields (responseStatus, cronJobs, columns,
 * addedToCampaignAt, etc.) are filled with safe defaults — Lead renders them
 * conditionally so empty values simply collapse those sections.
 */
export const toListPerson = (item: ListPersonGlobalSearchInfoDTO): ListPerson => ({
	id: item.id ?? 0,
	createdAt: new Date(item.createdAt),
	updatedAt: new Date(item.updatedAt),
	assignStatus: item.assignStatus ?? AssignStatus.DRAFT,
	plannedAssignStatus: null,
	responseStatus: ResponseStatus.DRAFT,
	inclusionStatus: item.inclusionStatus ?? InclusionStatus.ADDED,
	list: item.list ?? STUB_LIST,
	prospect: item.prospect,
	otherLists: item.otherLists ?? [],
	trackerSignalResult: item.trackerSignalResult ?? null,
	lastConversationAt: item.lastConversationAt ?? null,
	campaignId: item.campaignId ?? null,
	campaignConfig: item.campaignConfig ?? null,
	schedules: item.schedules ?? undefined,
	cronJobs: [],
	columns: [],
	addedToCampaignAt: new Date(item.createdAt),
	customColumns: null,
	additionalInformation: null,
	sourceName: null,
});
